import script from "./BranchenView.vue?vue&type=script&setup=true&lang=js"
export * from "./BranchenView.vue?vue&type=script&setup=true&lang=js"

import "./BranchenView.vue?vue&type=style&index=0&id=ec477c34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec477c34"]])

export default __exports__